import React, {PropTypes} from 'react';


class EarringAlert extends React.Component {

  static defaultProps = {};

  static propTypes = {
    alertTheme: PropTypes.string,
    alertNav: PropTypes.string,
    closeMethod: PropTypes.func.isRequired,
    closeText: PropTypes.string,
    open: PropTypes.bool.isRequired,
  };

  // Available themes
  // 'thankyou': Used after contact form - default
  // 'visit': Used after schedule appointments

  constructor(props) {
    super(props);
    this.state = {
      fullOpen: false,
      open: false,
      closing: false,
      bodyTop: 0,
      marginOffset: 0,
    };

    // Bind event listeners
    this.adjustHeight = ::this.adjustHeight;
    this.checkClick = ::this.checkClick;
  }

  componentWillMount() {
    window.addEventListener('resize', this.adjustHeight, false);
    document.addEventListener('click', this.checkClick, false);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.adjustHeight, false);
    document.removeEventListener('click', this.checkClick, false);
  }

  componentWillUpdate(nextProps, nextState) {
    if(this.state.open !== nextProps.open) {
      if(this.state.open && !nextProps.open && !this.state.closing) {
        this.closeAlert();
      } 
      if(nextProps.open) {
        this.openAlert();
      }
    }
  }

  checkClick(evt) {

    if(this.state.fullOpen === true) {
      let targetElement = evt.target;

      do {
          if (targetElement == this.alertBody) {
              return;
          }
          targetElement = targetElement.parentNode;
      } while (targetElement);

      // This is a click outside, should close
      this.props.closeMethod();
    }
  }

  getAlertBody() {
    let alert = null;
    let alerts = document.getElementsByClassName('alertBody');
    for(let i = 0; i < alerts.length; i++) {
      if(getComputedStyle(alerts[i], null).display === 'block') {
        alert = alerts[i];
        break;
      }
    }
    return alert;
  }

  adjustHeight() {
    let foundAlert = this.getAlertBody();
    if(foundAlert) {
      let offset = (window.innerHeight - (foundAlert.offsetHeight + 128)) / 2;
      this.setState({ marginOffset: offset > 0 ? offset + 'px' : 0 });
    }
  }

  openAlert() {

    this.setState({ open: true }, () => {
      let alert = null;
      do {
        alert = this.getAlertBody();
        setTimeout(() => {
          if(alert) {
            let offset = (window.innerHeight - (alert.offsetHeight + 128)) / 2;
            this.setState({ 
              bodyTop: '64px',
              marginOffset: offset > 0 ? offset + 'px' : 0, 
            });
          }
        }, 25);
      } while(!alert);
    });

    setTimeout(() => {
      this.setState({fullOpen: true});
    }, 400)
  }

  closeAlert() {
    this.setState({ 
      fullOpen: false,
      closing: true,
      bodyTop: '0',
    });
    setTimeout(() => {
      this.setState({
        open: false,
        closing: false,
      });
    }, 400)
  }

  alertStyles() {
    return {
      display: this.state.open ? 'block' : 'none', 
    }
  }

  closeHandler() {
    if(this.props.alertNav === null) {
      this.props.closeMethod();
    } else {
      window.location.href = '/' + this.props.alertNav;
    }
  }

  userNav(page) {
    this.props.closeMethod();
    window.location.href = '/' + page;
  }

  ggEarringNav() {
    window.location.href = 'https://gifts.diamondsdirect.com/';
  }

  render() {

    return (
      <div 
        className={this.state.closing ? 'EarringAlert RhinoAlert out' : 'EarringAlert RhinoAlert'} 
        style={this.alertStyles()}>
        <div 
          className='alertBody'
          ref={(alertBody) => { this.alertBody = alertBody; }}
          style={{
            display: this.state.open ? 'block' : 'none',
            top: this.state.bodyTop,
            marginTop: this.state.marginOffset,
            marginBottom: this.state.marginOffset === 0 ? '64px' : 0,
          }}>



          <div className='closeIcon' onClick={::this.props.closeMethod}>
            <div className='closeX'>&times;</div>
          </div>
          <div className='earringBackgroundWrapper'>
            <img className={'desktopBackground'}src='https://ddw2.diamondsdirect.com/img/alert/holiday-popup.jpg' />
            <img className={'mobileBackground'}src='https://ddw2.diamondsdirect.com/img/alert/holiday-popup-mobile.jpg' />
            <div className={'holidayTextLink'} onClick={() => this.userNav('locations')}>Click here for Locations</div>
            <div className={'earringBannerButton shopStoreButton'} onClick={() => this.userNav('locations')} style={{display: 'none'}}>Shop in Store</div>
            <div className={'earringBannerButton shopOnlineButton'} onClick={::this.ggEarringNav} style={{display: 'none'}}>Shop Online</div>
          </div>
        </div>
      </div>
    );
  }
}
export default EarringAlert;


// WEBPACK FOOTER //
// ./src/components/common/alert/EarringAlert.jsx